import React, { useEffect } from "react";
import { Box, Container, Typography, Paper, Alert } from "@mui/material";
import { useAuth } from "../../contexts/AuthContext";
import { GoogleSignInButton } from "./GoogleSignInButton";
import { useNavigate, useSearchParams } from "react-router-dom";

export const LoginPage: React.FC = () => {
  const { login, isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const error = searchParams.get("error");

  useEffect(() => {
    if (!loading && isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, loading, navigate]);

  if (loading) {
    return (
      <Container maxWidth="sm">
        <Box sx={{ mt: 8, textAlign: "center" }}>
          <Typography>Loading...</Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          mt: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Paper elevation={3} sx={{ p: 4, width: "100%", mt: 4 }}>
          <Typography component="h1" variant="h4" align="center" gutterBottom>
            Tradeventary
          </Typography>
          <Typography
            variant="body1"
            align="center"
            color="text.secondary"
            sx={{ mb: 4 }}
          >
            Sign in to access your trading journal
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 3 }}>
              Authentication failed. Please try again.
            </Alert>
          )}

          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <GoogleSignInButton onClick={login} />
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};
